module.exports = __webpack_public_path__ + "static/client4-d786815f0b1adf341d6e457fd3d242c6.png";